import LegalNotice from './LegalNotice'

export { LegalNotice }
